export default __webpack_public_path__ + "static/media/ITPharma2.72bce0ba.png";